import React, { Component } from 'react';
import { Modal, Button, Glyphicon } from 'react-bootstrap';
import { CodingWorksheet } from '../../components';

class WorksheetModal extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    hideModal = () => {
        this.props.closeModal();
    }

    render() {
        return (
            <>
                <Modal.Header>{this.props.title}</Modal.Header>
                <Modal.Body>
                    <CodingWorksheet />
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" onClick={this.hideModal}>Dismiss</Button>
                </Modal.Footer>
            </>
        )
    }
}

export default WorksheetModal